export const data = [
  {
    id: "react",
    name: "React",
    radiusFactor: 80,
    className: "has-svg-background-primary",
  },
  {
    id: "node",
    name: "Node.js",
    radiusFactor: 50,
    className: "has-svg-background-warning",
  },
  {
    id: "css",
    name: "CSS",
    radiusFactor: 60,
    className: "has-svg-background-link",
  },
  {
    id: "html",
    name: "HTML",
    radiusFactor: 60,
    className: "has-svg-background-success",
  },
  {
    id: "algorithms",
    name: "Algorithms",
    radiusFactor: 70,
    className: "has-svg-background-danger",
  },
  {
    id: "data structures",
    name: "Data Structures",
    radiusFactor: 70,
    className: "has-svg-background-danger",
  },
  {
    id: "D3.js",
    name: "D3.js",
    radiusFactor: 75,
    className: "has-svg-background-primary",
  },
  {
    id: "dbms",
    name: "DBMS",
    radiusFactor: 50,
    className: "has-svg-background-warning",
  },
  {
    id: "webrtc",
    name: "WebRTC",
    radiusFactor: 35,
    className: "has-svg-background-info",
  },
  {
    id: "typescript",
    name: "Typescript",
    radiusFactor: 50,
    className: "has-svg-background-info",
  },
  {
    id: "ecmascript",
    name: "ECMAScript",
    radiusFactor: 60,
    className: "has-svg-background-link",
  },
  {
    id: "git",
    name: "Git",
    radiusFactor: 40,
    className: "has-svg-background-success",
  },
  {
    id: "redux",
    name: "Redux",
    radiusFactor: 25,
    className: "has-svg-background-primary",
  },
]
